import React from "react";
import lottie from "./Media/Contact.json";
import Lottie from "lottie-react";
import { useMediaQuery } from "react-responsive";

function RequestConfirm() {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });
  return (
    <div className=" flex justify-center items-center h-screen pattern-bg2 border-b border-b-2 text-center modal-box-graident-border">
      <div className="main-bg  w-[90%] h-[100%] md:max-w-lg p-8 bg-white shadow-lg rounded-lg mt-[150px] mb-[3rem] md:mt-[100px]">
        <Lottie
          animationData={lottie}
          loop
          autoplay
          style={{
            width: isMobile ? "200px" : "400px",
            height: isMobile ? "200px" : "400px",
            background: "transparent",
            scale: 5,
            margin: "auto",
          }}
        />
        <span className="text-[35px] font-bold mb-4 text-pent">
          Confirm Your Email
        </span>
        <p className="text-gray-700 mb-4 mt-4">
          A confirmation email has been sent to your email address. Please check
          your inbox and follow the instructions to confirm your email.
        </p>

        <div className=" h-[1px]   m-auto  line-div"></div>
        <br />
        <p className="text-gray-700 mb-4">
          If you haven&apos;t received the email, please check your spam folder.
        </p>
      </div>
    </div>
  );
}

export default RequestConfirm;
